/**
 * 基础菜单 班组管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学员管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选  accordion -->
    <el-collapse ref="coll" v-model="activeCollapseNames">
      <el-collapse-item name="search">
        <template slot="title">
          <!-- 搜索区域折叠行 -->
          <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; width: 100%;" @click.stop="void 0">
            <div style="display: flex; flex-wrap: nowrap; align-items: center;">
              <el-form ref="queryForm" :inline="true" :model="queryParams" class="user-search">
                <el-form-item label="搜索：">
                  <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.className" placeholder="请输入班级"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" @focus="titleFocus" @blur="titleBlur" v-model="queryParams.idcard" placeholder="请输入身份证号"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                  <el-button size="small" type="primary" icon="el-icon-arrow-down" @click="toggleCollapse">{{ activeCollapseNames.length ? "收起" : "更多" }}</el-button>
                </el-form-item>
                <el-form-item style="position: absolute; right: 12px;">
                  <el-dropdown @command="openClass">
                    <el-button size="small" type="primary" icon="el-icon-refresh" >
                      恢复
                      <!--            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="0" v-show="queryParams.subjectId != '' && queryParams.subjectId != undefined">同科目</el-dropdown-item>
                      <el-dropdown-item command="1">跨科目</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>

        <!-- 这是折叠的内容区域 -->
        <div
          style="display: flex; flex-wrap: wrap;"
        >
          <el-form
            :model="queryParams"
            ref="queryForm2"
            :inline="true"
            label-width="68px"
          >
            <el-form-item label="" prop="subjectId">
              <!-- @change="findClassBySubjectId" -->
              <el-cascader
                size="small"
                style="width: 100%"
                v-model="queryParams.subjectId"
                :options="subjectOptions"
                emitPath="false"
                placeholder="请选择科目"
                :props="{ checkStrictly: true, emitPath:false }"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="">
              <el-date-picker
                size="small"
                v-model="dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-select size="small" v-model="queryParams.isDel" placeholder="请选择状态" clearable>
                <el-option
                  v-for="item in isDelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
    </el-collapse>



    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      :row-key="(row) => { return row.id }"
    >
      <el-table-column type="selection" width="55" align="center" :reserve-selection="true" :selectable="selected" />
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60">
      </el-table-column>
      <el-table-column prop="photo" label="头像" width="51">
        <template slot-scope="scope">
          <el-image
            style="width: 30px; height: 40px;"
            :src="scope.row.photo"
            :preview-src-list="[scope.row.photo]"
            fit="cover">
            <div slot="error" class="el-image__error">
              暂无头像
            </div>
            <div slot="placeholder" class="el-image__error">
              暂无头像
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="studenId" label="学号" width="100" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="100">
      </el-table-column>
      <el-table-column prop="idcardType" label="证件类别" width="100">
      </el-table-column>
      <el-table-column prop="idcard" label="身份证号" width="150">
      </el-table-column>
      <el-table-column prop="phone" label="手机号码" width="100">
      </el-table-column>
      <el-table-column prop="sex" label="性别" width="60">
        <template slot-scope="scope">
          {{ scope.row.sex == 1 ? '男' : scope.row.sex == 0 ? '女' : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="company" label="工作单位" width="120" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="subjectName" label="培训科目" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="marName" label="营销渠道" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="learnPlatformName" label="学习平台" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="payFeeStatus" label="支付情况" width="120">
        <template slot-scope="scope">
          {{ scope.row.payFeeStatus == '1' ? '已支付' : '未支付' }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="报名时间" width="150">
        <template slot-scope="scope">
          <div>{{timestampToTime(scope.row.createTime)}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="isDel" label="是否作废" width="100">
        <template slot-scope="scope">
          {{ scope.row.isDel == '1' ? '已作废' : '未作废' }}
        </template>
      </el-table-column>
      <el-table-column prop="wlxyFlag" label="是否发卡" width="100">
        <template slot-scope="scope">
          {{ scope.row.wlxyFlag == '1' ? '是' : '否' }}
        </template>
      </el-table-column>
<!--      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-tooltip
            v-show="scope.row.isDel == 1"
            class="item"
            effect="dark"
            content="恢复"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="recoverData(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>-->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 恢复对话框 -->
    <el-dialog :close-on-click-modal="false" title="换班列表" :visible.sync="classShow" width="60%" top="6vh"
               append-to-body>

      <el-form :inline="true" :model="queryParamsClass" class="user-search">
        <el-form-item label="搜索：">
          <el-input size="small" v-model="queryParamsClass.className" placeholder="输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="科目" prop="subjectId" v-if="subjectFlag == 1">
          <!-- @change="findClassBySubjectId" -->
          <el-cascader
            size="small"
            style="width: 100%"
            v-model="queryParamsClass.subjectId"
            :options="subjectOptions"
            emitPath="false"
            :props="{ emitPath:false }"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="searchClass">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table
        size="small"
        :data="classList"
        height="250"
        highlight-current-row
        v-loading="loading"
        border
        element-loading-text="拼命加载中"
        style="width: 100%;"
        @selection-change="classIdsChange"
        :row-key="(row) => { return row.id }"
      >
        <el-table-column type="selection" :selectable="selectable" width="55" align="center" :reserve-selection="true" />
        <el-table-column label="序号" align="center" type="index" width="60">
        </el-table-column>
        <el-table-column prop="subjectName" label="培训科目" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="className" label="班级名称" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="fee" label="收费价格" width="150">
        </el-table-column>
        <el-table-column prop="numberLimit" label="报名人数限制" width="150">
        </el-table-column>
        <el-table-column prop="studentNum" label="学生数" width="150">
        </el-table-column>
        <el-table-column prop="signUpEndTime" label="报名截止时间" width="180">
          <template slot-scope="scope">
            <div>{{scope.row.signUpEndTime ? scope.row.signUpEndTime : '不限制'}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="signUpStatus" label="是否公开报名" width="150">
          <template slot-scope="scope">
            {{ scope.row.signUpStatus == 1 ? '是' : '否' }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submitClass">确 定</el-button>
        <el-button size="small" @click="classShow = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  queryStudentList,
  saveStudent,
  updateStudent,
  deleteStudentById,
  queryStudentDetail, changeClass,

} from '../../api/student'
import { timestampToTime } from '../../utils/util'
import Pagination from '../../components/Pagination'
import Template from "../../components/template";
import {changeClassList} from "../../api/classInfo";
import {selectAreaTree} from "../../api/subjectTree";

export default {
  data() {
    return {
      // 恢复所需要的参数
      subjectId: '',    // 科目ID
      subjectOptions: [],
      subjectFlag: '',    // 同科目/跨科目
      classShow: false,
      ids: [],    // 多选框ids
      queryParamsClass: {},
      classList: [],
      classIds: [],


      // 查询折叠
      activeCollapseNames: [],
      dateValue: [],
      loading: false, //是显示加载
      // rules表单验证
      queryParams: {
        page: 1,
        size: 10
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      // 状态
      isDelOptions: [
        {value: '0', label: '在用'},
        {value: '1', label: '作废'}
      ]
    }
  },
  // 注册组件
  components: {
    Template,
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata()
    this.selectAreaTree()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    titleFocus() {
      this.collClick = this.$refs.coll.setActiveNames
      this.$refs.coll.setActiveNames = () => {}
    },
    titleBlur() {
      this.$refs.coll.setActiveNames = this.collClick
    },
    // 查询折叠
    toggleCollapse() {
      this.activeCollapseNames = this.activeCollapseNames.length ? [] : ["search"];
    },
    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.subjectOptions = res.data;
        }
      })
    },

    // 控制复选框
    selected(row, index) {
      return row.isDel == 1;
    },
    // 获取公司列表
    getdata() {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryStudentList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
          this.pageparm.pageSize = 10;

        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      if (this.dateValue.length > 0) {
        this.queryParams.startTime = timestampToTime(this.dateValue[0]).split(' ')[0];
        this.queryParams.endTime = timestampToTime(this.dateValue[1]).split(' ')[0];
      } else {
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
      }
      this.getdata()
    },


    /*
    *  恢复
    * */
    // 恢复列表 查询
    searchClass() {
      this.findClassBySubjectId()
    },
    // 多选框选中数据
    handleSelectionChange(val) {
      this.ids = JSON.parse(JSON.stringify(val));
    },

    // 打开恢复窗口
    openClass(x) {
      if (JSON.stringify(this.ids) == '[]') {
        this.$message.error('请选择需要恢复的学员！');
        return;
      }
      this.subjectFlag = x;
      this.classShow = true
      if (x == 0) {
        // 同科目  (取勾选数据的classId，直接查班级列表)
        changeClassList({subjectId: this.classItem.subjectId}).then(res => {
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.classList = res.data
          }
        })
        .catch(err => {
          this.$message.error('查询班级数据失败，请稍后再试！')
        })

      } else if (x == 1) {
        // 跨科目  (打开弹框，选择科目后，查询班级列表)
        changeClassList().then(res => {
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.classList = res.data
          }
        })
        .catch(err => {
          this.$message.error('查询班级数据失败，请稍后再试！')
        })
      }
    },

    // 选择班级
    classIdsChange(val){
      this.classIds = JSON.parse(JSON.stringify(val))
    },
    selectable(row) {
      if (this.classIds.length > 0) {
        if (this.classIds[0].id == row.id) {
          return true
        } else {
          return false
        }
      } else {
        return true;
      }
    },

    // 跨科目，选择科目后查询班组列表
    findClassBySubjectId() {
      if (this.queryParamsClass.subjectId) {
        changeClassList(this.queryParamsClass).then(res => {
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.classList = res.data
          }
        })
          .catch(err => {
            this.$message.error('查询班级数据失败，请稍后再试！')
          })
      }
    },

    submitClass() {
      // 处理数据
      var stuIds = []
      var classIds = []
      this.ids.forEach(x => {
        stuIds.push(x.id)
      })
      this.classIds.forEach(x => {
        classIds.push(x.id)
      })
      var params = {
        studentIds: stuIds.join(','),
        classId: classIds.join(',')
      }

      // 提交换班
      changeClass(params).then(res => {
        this.classShow = false;
        if (res.code == 200) {
          this.$message.success('恢复成功！');
          this.getdata()
        } else {
          this.$message.info(res.msg);
        }
      })
        .catch(err => {
          this.$message.error(err.response.data.msg);
        })
    },

    // 恢复 作废的数据
    recoverData(index, row) {
      this.$confirm('确定要恢复吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var params = {
            id: row.id,
            isDel: 0
          }
          updateStudent(params).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '恢复成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error('恢复失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消恢复'
          })
        })
    },
    // 格式化日期函数
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },


  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.btnCss {
  margin-top: 10px;
  margin-left: 0px !important;
}

/deep/ .el-collapse {
  margin-top: 10px !important;
  border-top: 0px solid #EBEEF5 !important;
  border-bottom: 0px solid #EBEEF5 !important;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0px;
}

/deep/ .el-collapse-item__arrow{
  display: none;
}

</style>





// WEBPACK FOOTER //
// src/views/system/student.vue